import { collection, getDocs, getCountFromServer } from "firebase/firestore";
import { db } from "../firebase/config.js";

export async function getAllReports() {
    try {
        const querySnapshot = await getDocs(collection(db, "reports"));
        const allReports = [];
        querySnapshot.forEach((doc) => {
            allReports.push({ id: doc.id, ...doc.data() });
        });
        return { success: true, reports: allReports };
    } catch (error) {
        console.error('Error getting reports:', error);
        return { success: false, error: error.message };
    }
}

export async function getReportsCount() {
    try {
        const coll = collection(db, "reports");
        const snapshot = await getCountFromServer(coll);
        const count = snapshot.data().count;
        return { success: true, count };
    } catch (error) {
        console.error('Error getting reports count:', error);
        return { success: false, error: error.message };
    }
}
